import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import { go } from '@platform/router.actions';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private store$: Store<RootState>) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.BadRequest || err.status === HttpStatusCode.InternalServerError) {
          this.store$.dispatch(go({ path: ['fatal-error'] }));
        }

        if (err.status === HttpStatusCode.Unauthorized) {
          this.store$.dispatch(go({ path: ['unauthenticated'] }));
        }

        if (err.status === HttpStatusCode.Forbidden) {
          this.store$.dispatch(go({ path: ['unauthorized'] }));
        }

        if (err.status === HttpStatusCode.NotFound) {
          this.store$.dispatch(go({ path: ['notfound'] }));
        }

        return throwError(() => err);
      }),
    );
  }
}
